import type { UserProfile } from "../store/auth.store";

export function canManageLegacyCases(
  profile: Pick<UserProfile, "permissions"> | null | undefined
): boolean {
  return Boolean(profile?.permissions?.includes("legacy_cases.manage"));
}

export function canReviewLegacyReports(
  profile: Pick<UserProfile, "permissions"> | null | undefined
): boolean {
  return (
    canManageLegacyCases(profile) ||
    Boolean(
      profile?.permissions?.includes("cases.read") &&
        profile.permissions.includes("sign_off.perform")
    )
  );
}
